import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';

import { combineLatest, map, take } from 'rxjs';

import { AuthSessionService } from '@core/services/auth-session.service';

export const pendingTermsGuard: CanActivateFn = () => {
  const router = inject(Router);
  const auth = inject(AuthSessionService);

  return combineLatest([auth.session$, auth.termsOfUse$]).pipe(
    take(1),
    map(([session, termsOfUse]) => {
      const user = session?.user;

      if (!user) {
        return true;
      }

      if (
        termsOfUse.length > 0 &&
        termsOfUse.every((row) => row.accepted === true)
      ) {
        return router.createUrlTree(['/inicio']);
      }

      return true;
    })
  );
};
